import { GroqImage } from '@/helpers/Image';
import { IArticle } from '@/lib/blog';
import { cn, getDescription, getTitle } from '@/lib/utils';
import Link from 'next/link';

export default function BlogCardXL({
  article,
  className,
}: {
  article: IArticle;
  className?: string;
}) {
  const slug = article?.settings?.slug?.current;
  return (
    <div
      className={cn(
        'lg:w-[81rem] w-full flex flex-col gap-[2.25rem]',
        className
      )}
      key={article?._id}
    >
      <div className="flex flex-col gap-[1.75rem]">
        <Link href={slug} className="h-[46.5rem] w-full overflow-clip group">
          {article?.mainImage && (
            <GroqImage
              src={article?.mainImage}
              alt={article.mainImage.name || 'Article image'}
              className="!w-full !h-full object-cover group-hover:scale-105 transition-transform duration-500"
            />
          )}
        </Link>

        <Link href={slug} className="flex flex-col gap-[1.25rem] group">
          <span className="block text-secondary font-roboto text-[1.375rem] font-semibold tracking-[-0.04125rem] uppercase mb-0 group-hover:opacity-80 transition-opacity duration-300">
            {article?.categories[0]}
          </span>
          <div className="gap-[1.25rem] flex flex-col">
            <h1 className="text-[5rem] ">
              {getTitle({ text: article?.title })}
            </h1>

            <p className="font-roboto text-white/80 font-medium tracking-[-0.06rem] leading-[160%] line-clamp-2 group-hover:opacity-80 transition-opacity duration-300">
              {getDescription({ text: article?.textContent })}
            </p>
          </div>
        </Link>
      </div>
    </div>
  );
}
